import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ChainSvg } from '../../../../assets';
import { styles } from '../../../../components/landing-page-wrapper/landing-page-wrapper-helper';
import { lifegraphExplorerEmptyStateStyles } from './lifegraph-explorer-helper';

interface LifegraphEmptyStateErrorProps {
    isCanvasHeightSmall?: boolean;
}

export const LifegraphEmptyStateError = ({
    isCanvasHeightSmall,
}: LifegraphEmptyStateErrorProps): React.JSX.Element => {
    return (
        <Grid
            sx={{
                ...lifegraphExplorerEmptyStateStyles.mainContainer,
                ...(isCanvasHeightSmall &&
                    lifegraphExplorerEmptyStateStyles.paddingStyles),
            }}
        >
            <Grid>
                <img
                    style={lifegraphExplorerEmptyStateStyles.errorImage}
                    src={ChainSvg}
                    alt='empty-state'
                />
            </Grid>
            <Grid sx={lifegraphExplorerEmptyStateStyles.headerTextContainer}>
                <Typography sx={styles.emptyHeadingText}>
                    Nothing to see here.
                </Typography>
            </Grid>
            <Grid sx={lifegraphExplorerEmptyStateStyles.subheaderTextContainer}>
                <Typography sx={styles.emptySubHeadingText}>
                    Oops! Either there&#39;s no data matching your query or you
                    don&#39;t
                    <br />
                    have rights to view this data. Please try a different query.
                </Typography>
            </Grid>
        </Grid>
    );
};
